"use client";
import { ComboBox } from "@/components/core/selects/ComboBox";
import { Input } from "@/components/ui/input";
import { resourceTypes } from "@/lib/types/resource";
import { constructUrlWithParams } from "@/lib/utils/func-1";
import { debounce } from "lodash-es";
import { Search } from "lucide-react";
import { useRouter } from "next/navigation";

const Filters = ({
  searchParams,
}: {
  searchParams: { type?: string; search?: string };
  types?: { label: string; value: string }[];
}) => {
  const router = useRouter();

  const handleSearch = debounce((value: string) => {
    const url = constructUrlWithParams("/resources", {
      ...searchParams,
      search: value,
    });
    router.push(url);
  }, 500);

  const typeOptions = [
    { label: "All Types", value: "all" },
    ...resourceTypes.map((type) => ({
      label: type.replace(/_/g, " ").toLowerCase(),
      value: type,
    })),
  ];

  return (
    <div className="mb-8 flex sm:justify-end">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 w-full sm:w-1/2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
          <Input
            placeholder="Search resources..."
            className="pl-10"
            defaultValue={searchParams.search}
            name="search"
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
        <ComboBox
          data={typeOptions}
          value={searchParams.type}
          placeholder="Filter by type"
          className="w-fit capitalize"
          onChange={(value) => {
            const url = constructUrlWithParams("/resources", {
              ...searchParams,
              type: value,
            });
            router.push(url);
          }}
        />
      </div>
    </div>
  );
};

export default Filters;
